<template>
  <div v-if="product" class="product-info">
    <div class="content desktop flex-grid">
      <div class="flex-col-6-md">
        <div v-if="product.description" class="description-container row large">
          <p>{{ product.description }}</p>
        </div>
        <Specs class="row large" />
      </div>
      <div class="flex-col-6-md">
        <PreserveRatio :width="2890" :height="1500" class="row large">
          <div v-if="lastImage && mounted" ref="dimensionContainerDesktop" class="dimension-container" :key="lastImage.url">
            <div class="dimension-img" @mouseover="updateTransform($event)" @mousemove="updateTransform($event)" @mouseout="resetTransform($event)">
              <ResponsiveImage :url="lastImage.url + '?fit=max&w={width}&q={q}'" :lazy="false" />
            </div>
          </div>
        </PreserveRatio>
        <Features class="row large" />
        <Care class="row large" />
        <Collections class="row large" />
      </div>
    </div>
    <div class="content mobile">
      <div class="tabs-heads">
        <div
          v-for="(tab, index) in tabs"
          :key="index"
          class="tabs-head"
          :class="{ active: tabActive == index }"
          @click.passive="onTabClicked($event, index)"
        >
          <h5>{{ tab }}</h5>
        </div>
      </div>
      <div class="tabs-contents">
        <div v-if="tabActive == 0" class="tabs-content">
          <div v-if="product.description" class="description-container row large">
            <p>{{ product.description }}</p>
          </div>
          <Features class="row large" />
          <Care class="row large" />
        </div>
        <div v-if="tabActive == 1" class="tabs-content">
          <PreserveRatio :width="2890" :height="1500" class="row large">
            <div v-if="lastImage && mounted" class="dimension-container" :key="lastImage.url">
              <div class="dimension-img">
                <ResponsiveImage :url="lastImage.url + '?fit=max&w={width}&q={q}'" :lazy="false" />
              </div>
            </div>
          </PreserveRatio>
          <Specs class="row large" />
        </div>
      </div>
      <Collections class="row large" />
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import { Image, PreserveRatio } from '@article/pixel';
import Specs from './Specs.vue';
import Features from './Features.vue';
import Care from './Care.vue';
import Collections from './Collections.vue';
import ResponsiveImage from '@/components/commons/ResponsiveImage.vue';

export default {
  name: 'ProductInfo',
  components: {
    ResponsiveImage,
    PreserveRatio,
    Specs,
    Features,
    Care,
    Collections,
  },
  data() {
    return {
      tabs: ['Description', 'Specifications'],
      tabActive: 0,
      mounted: false
    };
  },
  computed: {
    ...mapState('product', [
      'product', //
    ]),
    ...mapGetters('product', [
      'lastImage', //
    ]),
  },
  mounted() {
    this.mounted = true;
  },
  methods: {
    onTabClicked(event, index) {
      this.tabActive = index;
    },
    updateTransform(event) {
      const { target, clientX, clientY } = event;
      const { dimensionContainerDesktop } = this.$refs;
      const domRect = dimensionContainerDesktop.getBoundingClientRect();
      const originLeft = ((clientX - domRect.left) / domRect.width) * 100;
      const originTop = ((clientY - domRect.top) / domRect.height) * 100;
      target.style.transform = 'scale(1.6)';
      target.style.transformOrigin = `${originLeft}% ${originTop}%`;
    },
    resetTransform(event) {
      const { target } = event;
      target.removeAttribute('style');
    },
  },
};
</script>

<style lang="scss">
@import '~@article/pixel/dist/style/variables';

.product-info {
  .content {
    &.desktop {
      @media (max-width: $tablet-breakpoint - 1) {
        display: none;
      }

      .flex-col-6-md:first-child {
        padding-right: 40px;
      }

      .flex-col-6-md:last-child {
        padding-left: 40px;
      }

      .row {
        &.large {
          margin-bottom: 20px;
        }
      }
    }

    &.mobile {
      @media (min-width: $tablet-breakpoint) {
        display: none;
      }

      .tabs-heads {
        display: flex;
        justify-content: space-around;

        .tabs-head {
          cursor: pointer;
          text-align: center;
          padding: 6px 0 4px;
          width: 100%;
          border-radius: 0 10px 0 0;

          &.active {
            color: var(--font-color);
            background: var(--background-color);
          }
        }
      }

      .tabs-content {
        background: var(--background-color);

        padding: 20px;

        .dimension-container {
          margin-bottom: 20px;
        }
      }
    }

    .dimension-container {
      overflow: hidden;
    }
  }

  .divider {
    @media (max-width: $tablet-breakpoint - 1) {
      display: none;
    }
  }
}
</style>
